import { Link } from 'react-router-dom';
import PageSEO from '../Components/PageSEO';
import { getPageSeo } from '../Utils/seoConfig';
import { useLanguage } from '../i18n/LanguageContext';

function PageNotFound() {
  const { locale } = useLanguage();
  const seo = getPageSeo('notFound', locale);

  return (
    <>
      <PageSEO {...seo} path="/404" noindex />
      <style dangerouslySetInnerHTML={{__html: `
        @import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&family=Fira+Mono:wght@500&display=swap');

        body {
            height: 95vh;
            background: #000000;
            text-align: center;
            color: #E0E0E0;
            font-family: 'Fira Mono', monospace;
        }

        h1 {
            font-size: 2.5rem;
            font-family: 'Permanent Marker', cursive;
        }

        div {
            transform-style: preserve-3d;
        }

        svg {
            width: clamp(300px, 70%, 600px);
            height: 500px;
        }

        #rocket {
            transform: translateY(750px);
            animation: launch 2s ease-out forwards;
        }

        @keyframes launch {
            from { transform: translateY(750px); }
            to { perspective: 500px; transform: translateY(0px); }
        }

        #stars { animation: twinkling 2s linear; }

        @keyframes twinkling {
            from { transform: scale(0); }
            to { transform: scale(1); }
        }

        .text {
            opacity: 0;
            animation: appear 1s ease-in forwards;
            animation-delay: 1.8s;
        }

        @keyframes appear {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        a { color: #F66947; text-decoration: none; }
    ` }} />
        <div>
          <svg width={1123} height={837} viewBox="0 0 1123 837" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width={1123} height={837} fill="black" />
            <g id="sky" filter="url(#filter0_d)">
              <rect id="background" x={30} y={26} width={1063} height={777} rx={20} fill="black" />
              <g id="stars">
                <path d="M202.12 319.2C204.937 319.2 207.22 316.917 207.22 314.1C207.22 311.283 204.937 309 202.12 309C199.303 309 197.02 311.283 197.02 314.1C197.02 316.917 199.303 319.2 202.12 319.2Z" fill="white" />
              </g>
              <g id="rocket">
                <path d="M635.46 400H466V406.78H635.46V400Z" fill="#535461" />
              </g>
            </g>
          </svg>
        </div>
        <div className="text">
          <h1>404 Error</h1>
          <h2>Couldn&apos;t launch</h2>
          <h3>Page Not Found — take me <Link to="/">home</Link></h3>
        </div>
    </>
  );
}

export default PageNotFound;
